/*
 * AddFiles Messages
 *
 * This contains all the text for the AddFiles component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  skipPreviews: {
    id: 'app.components.AddFiles.skipPreviews',
    defaultMessage: 'When uploading many images, previews will only be created for the first {count} images. This does not affect how images will be displayed in the post.',
  },
  understand: {
    id: 'app.common.understand',
    defaultMessage: 'I understand!',
  },
  this: {
    id: 'app.components.Form.this',
    defaultMessage: 'This',
  },
  loading: {
    id: 'app.components.AddFiles.loading',
    defaultMessage: 'Uploading files...',
  },
});
